export default {
  labels: {
    reply: 'Respuesta del propietario',
  },
  form: {
    reply_text: {
      placeholder: 'Escribe tu respuesta...',
    },
  },
  buttons: {
    generate_reply: 'Generar respuesta',
    submit_reply: 'Enviar respuesta',
  },
  toasts: {
    failed_to_create_reply: 'Error al crear la respuesta',
    failed_to_generate_ai_reply: 'Error al generar la respuesta con IA',
  },
};
